import React from 'react';
import Validation from 'react-validation';
import validator from 'validator';

Object.assign(Validation.rules, {    
    required: {
        rule: value => {
            return value.toString().trim();
        },
        hint: value => {
            return <span className='is-invalid-input'>Må ha verdi</span>
        }
    },
    numeric: {
        rule: value => validator.isNumeric(value),
        hint: () => (
            <span className="is-invalid-input">
                Må være tall
            </span>
        )
    },
    
    storreEllerLikNull: {
        rule: value => validator.isNumeric(value) && value >= 0,
        hint: () => (
            <span className="is-invalid-input">
                Må være større enn null
            </span>
        )
    },

    mindreEnn512Tegn: {
        rule: value => !value || value.toString().length < 512,
        hint: () => (
            
            <span className="is-invalid-input">
                Kan ikke være mer enn 512 tegn
            </span>
        )
    },
    mindreEnn50Tegn: {
        rule: value => value.toString().length < 50,
        hint: () => (
            
            <span className="is-invalid-input">
                Kan ikke være mer enn 50 tegn
            </span>
        )
    },
    mindreEnn100Tegn: {
        rule: value => value.toString().length < 100,
        hint: () => (
            
            <span className="is-invalid-input">
                Kan ikke være mer enn 100 tegn
            </span>
        )
    },
   
})


// WEBPACK FOOTER //
// ./src/felles/valideringsRegler.jsx